import { render, staticRenderFns } from "./newUserOnline.vue?vue&type=template&id=1d5b86d4&scoped=true"
import script from "./newUserOnline.vue?vue&type=script&lang=js"
export * from "./newUserOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b86d4",
  null
  
)

export default component.exports